// extracted by mini-css-extract-plugin
export default {"apple-pay-button-white":"_Nmej_gRFy_Hq1xurqGp","applePayButtonWhite":"_Nmej_gRFy_Hq1xurqGp"};